import { render, staticRenderFns } from "./SampleOrderDetail.vue?vue&type=template&id=5a08759a&scoped=true"
import script from "./SampleOrderDetail.vue?vue&type=script&lang=js"
export * from "./SampleOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./SampleOrderDetail.vue?vue&type=style&index=0&id=5a08759a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08759a",
  null
  
)

export default component.exports